export default function (vue) {
    /**
     * @desc fixed 在页面底部
     */
    vue.directive('fixed-bottom', function fixed(el, binding) {
        var ch = parseInt(document.documentElement.dataset.ch || document.documentElement.clientHeight);
        var btm = binding.value || 0;

        if (typeof btm !== 'number') {
            return console.error('the value of the directive fixed-bottom must be Number')
        }

        vue.nextTick(() => {
            var h = el.clientHeight;
            el.style.top = (ch - h - btm) + 'px';
        })

        window.addEventListener('resize', ()=>{
            vue.nextTick(() => {
                var h = el.clientHeight;
                var _ch = document.documentElement.clientHeight;
                
                if(Math.abs(ch-_ch)<100){
                    el.style.display="";
                    el.style.top = (_ch - h - btm) + 'px';
                }else{
                    el.style.display="none";
                }
            })
        }, false)
    });

    vue.directive('validate-input', {
        bind(el, binding, vnode) {
            var instance = vnode.componentInstance;
            var timmer = null,
                params = {
                    delay: 3000
                }

            if (typeof binding.value !== 'function' && typeof binding.value !== 'object') {
                return console.error('directive args mast be a Function or a Object')
            }

            if (typeof binding.value === 'function'){
                params = {
                    vfn: binding.value,
                    delay: 3000
                }
            }else{
                params = {
                    ...params,
                    ...binding.value
                }
            }

            instance.$on('focus', () => {
                //
            })

            instance.$on('blur', () => {
                if (timmer) {
                    clearTimeout(timmer)
                    timmer = null
                }
                params.vfn().catch((err) => {
                    instance.$emit('validate-error', err);
                    instance.$emit('validate-end')
                });

                instance.$emit('validate-end')
            })

            instance.$on('input', () => {
                instance.$emit('validate-error', '');
                instance.$emit('validate-start')
                if (timmer) {
                    clearTimeout(timmer)
                    timmer = null
                }
                
                params.vfn().then(()=>{
                    instance.$emit('validate-error', '');
                    instance.$emit('validate-end')
                },(err) => {
                    timmer = setTimeout(() => {
                        instance.$emit('validate-error', err);
                        instance.$emit('validate-end')
                    }, params.delay)
                });
            })
        }
    })
}



// WEBPACK FOOTER //
// ./src/utils/directives/index.js